import React, { memo } from 'react';

function ProtectBar() {
  return (
    <div className="protect-bar">
      <div className="protect-bar-container" />
    </div>
  );
}

export default memo(ProtectBar);
